import { Controller } from "@hotwired/stimulus"

// Tokenless /tv boots here. Replay a stored device token (saved by
// beacon_pairing_controller) so a reload returns to the SAME beacon instead of
// minting a new one. With no stored token, fall through to a fresh mint.
export default class extends Controller {
  connect() {
    let token = null
    try { token = window.localStorage.getItem("win.beacon.token") } catch (e) {}
    if (token) {
      window.location.replace(`/tv?token=${encodeURIComponent(token)}`)
    } else {
      window.location.replace("/tv?fresh=1")
    }
  }
}
